import React from 'react';
import { useHistory } from 'react-router-dom';
import { Transition } from 'react-transition-group';
import Card from './cards/Card';
import { Backdrop } from '@material-ui/core';
import FabGroup from './buttons/FabGroup';
import { useSelector } from 'react-redux';

const duration = 300;

const defaultStyle = {
  transition: `bottom ${duration}ms ease-in-out`,
  position: 'fixed',
  bottom: '-50%'
};

const transitionStyles = {
  entering: { bottom: 110 },
  entered: { bottom: 110 },
  exiting: { bottom: '-50%' },
  exited: { bottom: '-50%' }
};

const SliderDialog = () => {
  const history = useHistory();
  const dialogStates = useSelector((state) => state.sliderDialogReducer);

  const closeDialog = () => {
    // dispatch(closeSliderDialogAction())
    history.goBack();
  };

  return (
    <Transition
      in={dialogStates.show}
      timeout={duration}
      mountOnEnter
      unmountOnExit
    >
      {(state) => (
        <Backdrop
          open={dialogStates.show}
          style={{ zIndex: 9999 }}
          onClick={closeDialog}
        >
          <div className="backdrop" />
          <Card
            scrollable
            noPointer
            onClick={(e) => e.stopPropagation()}
            extraStyle={{
              ...defaultStyle,
              ...transitionStyles[state],
              width: '90%',
              maxHeight: 'calc(100vh - 126px)',
              maxWidth: '600px',
              overflow: 'auto'
            }}
          >
            {dialogStates.content}
          </Card>
          <FabGroup buttons={dialogStates.fab} />
        </Backdrop>
      )}
    </Transition>
  );
};

SliderDialog.propTypes = {};

export default SliderDialog;
